<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card v-if="hasTeamData">
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Siedziba {{ team.name }}
                </h1>
            </v-card-title>

            <v-card-text>
                <div>
                    <strong>Adres:</strong> {{ team.street }}, {{ team.postCode }} {{ team.city }}
                </div>
                <div>
                    <strong>Telefon:</strong> {{ team.phoneNumber }}
                </div>
                <div v-if="team.coordinator">
                    <strong>Koordynator:</strong> {{ team.coordinator.firstName }} {{ team.coordinator.lastName }}
                </div>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
    name: 'TeamDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        team: {
            type: Object,
            default: null
        }
    },
    computed: {
        hasTeamData() {
            return !isEmpty(this.team)
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>